import { useGetAuctionIdQuery } from '../../generated/graphql'

const useAuctionId = (): string => {
    const { data } = useGetAuctionIdQuery()

    const { orgId: auctionId } = (data && data.activeOrganization) || {}

    return auctionId || ''
}

export default useAuctionId
